module.exports = __webpack_public_path__ + "static/media/userImg.54e9ec53.png";